import isString from 'lodash/isString'

export default isString
